import {
  IAllocationActivity,
  IAllocationBudgetControl,
  IAllocationCostCenter,
  IAllocationLineItem,
  IAllocationLink,
  IAllocationReadiness,
  IAllocationSummary,
} from './budgetallocation.models';

const n=(value:any,fallback=0)=>{
  const result=Number(value);
  return Number.isFinite(result)?result:fallback;
};

const s=(value:any,fallback='')=>
  value===null||value===undefined?fallback:String(value);

// export const normalizeAllocationCostCenter=(r:any):IAllocationCostCenter=>({
//   recid:n(r.recid??r.rid??r.id),
//   shortcode:s(r.shortcode??r.shc??r.costcentercode??r.ccc),
//   recname:s(r.recname??r.nam??r.costcentername??r.ccn),
//   activity_count:n(r.activity_count??r.activities??r.act),
//   allocated_amount:n(r.allocated_amount??r.amount??r.amt),
// });

export const normalizeAllocationActivity=(r:any):IAllocationActivity=>({
  id:r.activityplanid??r.recid??r.rid,
  recid:r.activityplanid??r.recid??r.rid,
  activityplanid:r.activityplanid??r.recid??r.rid,
  activityid:r.activityid??r.aci,
  shortcode:s(r.shortcode??r.activitycode??r.shc),
  recname:s(r.recname??r.activityname??r.nam),
  description:s(r.description??r.dsc),
  ccid:r.ccid??r.costcenterid,
  costcenter_code:s(r.costcenter_code??r.costcentercode??r.ccc),
  costcenter_name:s(r.costcenter_name??r.costcentername??r.ccn),
  periodid:r.periodid??r.pei,
  periodcode:s(r.periodcode??r.pec),
  cycleid:r.cycleid??r.cyi,
  cyclecode:s(r.cyclecode??r.cyc),
  plannedamount:n(r.plannedamount??r.planned_amount??r.pam),
  allocation_count:n(r.allocation_count??r.links),
  allocated_amount:n(r.allocated_amount??r.amount??r.amt),
  remainingamount:n(r.remainingamount??r.remaining_amount??r.rem),
  allocation_status:s(r.allocation_status??r.statusname),
  statecode:s(r.statecode??r.stc),
  statename:s(r.statename??r.stn),
});

export const normalizeAllocationLineItem=(r:any):IAllocationLineItem=>({
  id:r.recid??r.rid??r.id,
  recid:r.recid??r.rid??r.id,
  shortcode:s(r.accountcode??r.shortcode??r.shc),
  displaycode:s(r.displaycode??r.lineitemcode??r.shortcode??r.shc),
  recname:s(r.recname??r.nam??r.accountname),
  description:s(r.description??r.dsc),
  budgetplanid:r.budgetplanid??r.bpi,
  code_length:n(r.code_length??r.codelength),
  allocation_count:n(r.allocation_count??r.links),
  allocated_amount:n(r.allocated_amount??r.amount??r.amt),
});

export const normalizeAllocationLink=(r:any):IAllocationLink=>({
  id:r.recid??r.rid??r.id,
  recid:r.recid??r.rid??r.id,
  budgetplanid:r.budgetplanid??r.bpi,
  activityplanid:r.activityplanid??r.api,
  activityid:r.activityid??r.aci,
  activity_code:s(r.activity_code??r.activitycode),
  activity_name:s(r.activity_name??r.activityname),
  ccid:r.ccid??r.costcenterid,
  costcenter_code:s(r.costcenter_code??r.costcentercode),
  costcenter_name:s(r.costcenter_name??r.costcentername),
  lineitemid:r.lineitemid??r.accountid,
  lineitem_code:s(r.accountcode??r.lineitem_code??r.lineitemcode),
  lineitem_displaycode:s(r.lineitem_displaycode??r.lineitemcode),
  lineitem_name:s(r.lineitem_name??r.lineitemname),
  allocationratio:n(r.allocationratio??r.ratio),
  allocatedamount:n(r.allocatedamount??r.allocated_amount??r.amount),
  status:n(r.status??r.sts,1),
});

export const normalizeAllocationSummary=(r:any):IAllocationSummary=>({
  costcenters:n(r?.costcenters??r?.costcenter_count),
  activities:n(r?.activities??r?.activity_count),
  allocated_activities:n(r?.allocatedactivities??r?.allocated_activities),
  unallocated_activities:n(r?.unallocatedactivities??r?.unallocated_activities),
  allocation_links:n(r?.allocationlinks??r?.allocation_links??r?.links),
  planned_amount:n(r?.plannedamount??r?.planned_amount),
  allocated_amount:n(r?.allocatedamount??r?.allocated_amount??r?.amount),
  remaining_amount:n(r?.remainingamount??r?.remaining_amount),
});

export const normalizeActivityBudgetControl=(raw:any):IAllocationBudgetControl=>{
  const source=Array.isArray(raw)
    ?raw.find(item=>String(item?.controlareacode??'').toUpperCase()==='ACTIVITY')
    :raw?.controlareacode
      ?raw
      :{};

  return {
    budgetcontrolid:source?.budgetcontrolid??null,
    statecode:s(source?.statecode),
    iscurrent:n(source?.iscurrent),
    controlareacode:'ACTIVITY',
    controlareaname:s(source?.controlareaname,'Activity Budget'),
    ceilingamount:n(source?.ceilingamount),
    allocatedamount:n(source?.allocatedamount),
    availableamount:n(source?.availableamount),
    utilisationpercent:n(source?.utilisationpercent),
    warningpercent:n(source?.warningpercent,90),
    controlstatus:s(source?.controlstatus,'UNAVAILABLE'),
    currencycode:s(source?.currencycode,'XOF'),
  };
};

export const deriveAllocationReadiness=(
  activities:IAllocationActivity[],
  control:IAllocationBudgetControl,
):IAllocationReadiness=>{
  const rows=activities??[];

  return {
    controlavailable:Boolean(control.budgetcontrolid)
      &&['ACTIVE','REVIEWED','DRAFT'].includes(
        String(control.statecode??'').toUpperCase(),
      ),
    withincontrol:
      Number(control.allocatedamount)<=Number(control.ceilingamount),
    activitycount:rows.length,
    mappedactivitycount:rows.filter(
      row=>Number(row.allocation_count??0)>0,
    ).length,
    unmappedactivitycount:rows.filter(
      row=>Number(row.allocation_count??0)===0,
    ).length,
    ratioonlycount:rows.filter(
      row=>String(row.allocation_status??'').toUpperCase()==='RATIO_ONLY',
    ).length,
    fullyallocatedcount:rows.filter(
      row=>Number(row.remainingamount??0)===0
        &&Number(row.plannedamount??0)>0,
    ).length,
  };
};

export const normalizeAllocationCostCenter = (
  r: any
): IAllocationCostCenter => ({
  recid: n(
    r.recid ??
    r.rid ??
    r.id ??
    r.costcenterid
  ),

  shortcode: s(
    r.shortcode ??
    r.shc ??
    r.costcentercode ??
    r.ccc
  ),

  recname: s(
    r.recname ??
    r.nam ??
    r.costcentername ??
    r.ccn
  ),

  budgetplanid: n(
    r.budgetplanid ??
    r.budget_plan_id
  ),

  activity_count: n(
    r.activitycount ??
    r.activity_count ??
    r.activities ??
    r.act
  ),

  planned_amount: n(
    r.plannedamount ??
    r.planned_amount
  ),

  allocated_amount: n(
    r.allocatedamount ??
    r.allocated_amount ??
    r.amount ??
    r.amt
  ),
});